import { createSlice } from '@reduxjs/toolkit';


// Define the initial state using that type
const initialState: IBaasRaasState = {
    data: null,
    racks: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null
};

export const baasRaasSlice = createSlice({
    name: 'baasRaas',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceBaasRaas: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        replaceRacks: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.racks = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        addBaasRaas: (state, action) => {
            const newItem = action.payload.data;
            if (state.data && state.data.length > state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount = state.totalCount + 1;
        },
        updateBaasRaas: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
                state.data[localID] = data;
            }
            state.details = data;
        },
        updateBaasRaasRack: (state, action) => {
            const { data } = action.payload;
            const localIndex = state.racks?.findIndex(
                (x: IRackDetails) => x.id === parseInt(data.id)
            );
            if (localIndex !== undefined && localIndex >= 0 && state.racks) {
                state.racks[localIndex] = data;
            }
        },
        deleteBaasRaas: (state, action) => {
            const baasRaasToRemove: IBaasRaasReservation = action.payload.data;
            const newBaasRaasData = state.data && state.data.filter(
                (baasRaas: IBaasRaasReservation) => {
                    return (
                        baasRaas.id !== baasRaasToRemove.id
                    );
                }
            );
            state.data = newBaasRaasData;
            state.totalCount = state.totalCount - 1;
        },
        setBaasRaasDetails: (state, action) => {
            state.details = action.payload.data;
        },
        setRacks: (state, action) => {
            state.racks = action.payload.data;
        }
    },
});

export const baasRaasActions = baasRaasSlice.actions;

export default baasRaasSlice.reducer;